import { MenuNodeType } from "components/Menu/model";

export const isLanguageContainerNode = (
  node: MenuNodeType.Any
): node is MenuNodeType.Language => {
  return (
    node.nodeType === "container" &&
    node.customChildNodeComponent === "changeLanguage"
  );
};
